<template>
  <div class="accordion-with-image__item-child">
    <sc-text
      tag="h4"
      class="accordion-with-image__item-child--title"
      v-if="fields && fields.title"
      :field="fields.title"
    />
    <sc-rich-text
      tag="div"
      class="accordion-with-image__item-child--content"
      v-if="fields && fields.content"
      :field="fields.content"
    />
  </div>
</template>

<script>
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Accordion-With-Image-Item-Child',
  components: {
    ScText: Text,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
